import { combineReducers } from "redux";
import { coursesReducer } from "./coursesReducer";
import { usersReducer } from "./usersReducer";
import { kholasehVaziatsReducer } from "./kholasehVaziatsReducer";
import { historiesReducer } from "./historiesReducer";
import { zirmajmoehsReducer } from "./zirmajmoehsReducer";
import { varizhaReducer } from "./varizhaReducer";
import { dariafthaReducer } from "./dariafthaReducer";




export const reducers = combineReducers({
    courses: coursesReducer,
    user: usersReducer,
    kholasehVaziats:kholasehVaziatsReducer,
    historyes:historiesReducer,
    zrmajmoeh:zirmajmoehsReducer,
    varizhas:varizhaReducer,
    dariafthas:dariafthaReducer
});
